/*
---
description: FED Process
authors:
- David Chan CK
- Anton Burov
license:
- MIT-style license
requires:
- core/1.4.1: '*'
- more/1.4.0.1: [Fx.Accordion]
provides: [Ava]
...
*/
var PriceHistory = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_pricehistory',
		scroll_at_a_time: 1
	},

	initialize: function(_element, options) {
		this.setOptions(options);
		this._element = _element || document.getElement('.w_pricehistory');

		if (this._element) {
			this.build();
		}
	},

	build: function(){
		this._toggler = this._element.getElement('.ph_toggler');
		this._container = this._element.getElement('.ph_container');
		this._close = this._element.getElement('.close');

		this.rpc_request();

		this.set_opener();
	},

	set_opener: function(){
		var self = this;
		this.max_width = this._container.getSize().x;
		this._container.setStyle('width', 0);

		if(this._toggler){
			var fx_ph = new Fx.Morph(this._container, {
				link: 'cancel',
				duration: 300,
				transition: Fx.Transitions.linear
			});

			this._toggler.addEvent('click', function(){
				self._container.toggleClass('opened');

				if(self._container.hasClass('opened')){
					fx_ph.start({'width': self.max_width});
					self._toggler.set('html', '<span>&nbsp;</span>Hide Price History');
				}else{
					fx_ph.start({'width': 0});
					self._toggler.set('html', '<span>&nbsp;</span>Show Price History');
				}
			});

			if(self._element.hasClass('rent')){
				self._toggler.fireEvent('click');
				self._toggler.dispose();
				self._close.dispose();
			}else{
				if(self._close){
					self._close.addEvent('click', function(){
						self._container.removeClass('opened');

						fx_ph.start({'width': 0});
						self._toggler.set('text', 'Show Price History');
					});
				}
			}
		}
	},

	rpc_request: function(){
		var self = this;
		var url = this._toggler.getProperty('data-rpc');

		if(url && url != ''){
			new Remote({
				rpc: url + '&mode=j',
				onSuccess: function(){ self.post_process_build(this) },
				onError: this.display_basic
			});
		}
	},

	display_basic: function(){
		this._container.addClass('_no_change');

		var text = 'No Price Change';

		if(this.data && this.data.length > 0){
			text += ' Since ' + this.data[0].date;
		}

		new Element('div', {'class': 'msg', 'text': text}).inject(this._diagram, 'after');
		this._diagram.dispose();
	},

	post_process_build: function(remote){
		var data = this.data = remote.get_data();

		this._diagram = this._element.getElement('.diagram');

		if(data.length > 1){
			new Phgraph(this._element.getElement('.diagram'), {data: data});
		}else{
			this.display_basic();
		}
	}
});
